;(function() {

    function line($element, options) {
        var result = $.extend({
            offset: 0,
            offsetLimit: 0,
            tileWidth: 0,
            childSelector: '.js-Line-item',
            elements: {
                $root  : $element,
                $holder: null, // @NOTE(Grey): this is created `$.wrap` time
                $nav   : $('<div class="Line-nav"></div>'),
                $prev  : $('<button class="Line-nav-prev" disabled>Prev</button>'),
                $next  : $('<button class="Line-nav-next">Next</button>')
            },

            shift: function(amount) {
                var els = this.elements;

                this.offset += amount;
                els.$root.css({
                    'transform': 'translateX(' + this.offset + 'px)' });

                els.$next.prop('disabled', false);
                els.$prev.prop('disabled', false);

                if (this.offset < this.offsetLimit) {
                    els.$next.prop('disabled', true);
                }

                if (this.offset === 0) {
                    els.$prev.prop('disabled', true);
                }

                this.fade();
            },

            fade: function() {
                var els = this.elements;
                var box = els.$holder[0].getBoundingClientRect();
                var $tiles = els.$root.find(this.childSelector);

                var offsetIndex = -(this.offset / this.tileWidth);
                var numberOfTilesToShow = Math.floor(box.width / this.tileWidth);
                var fadeThresholdIndex = offsetIndex + numberOfTilesToShow;

                $tiles.each(function(i, tile) {
                    var $tile = $(tile);
                    if (i >= fadeThresholdIndex || i <= offsetIndex - 1) {
                        $tile.addClass('is-faded')
                    } else {
                        $tile.removeClass('is-faded')
                    }
                });
            },

            _onClick: function(event) {
                var target = event.target;
                var els = this.elements;

                if (target === els.$next[0]) this.shift(-this.tileWidth);
                if (target === els.$prev[0]) this.shift(this.tileWidth);
            },

            init: function() {
                var els = this.elements;

                // @NOTE(Grey): I use the second tile in sequence because the first
                // does not have the padding I want for the measurement
                if (els.$root.find(this.childSelector).length > 1) {
                    this.tileWidth = $(els.$root.find(this.childSelector)[1])
                        .outerWidth(true);
                } else {
                    this.tileWidth = 0;
                }
                this.offsetLimit = els.$root[0].clientWidth - els.$root[0].scrollWidth;

                if (this.offsetLimit < 0) {
                    els.$root.css({'overflow-x': 'visible'});
                    els.$nav.on('click', this._onClick.bind(this));

                    els.$nav.append(els.$prev, els.$next);
                    els.$root.wrap('<div class="Line-holder" style="position: relative;" />');
                    els.$holder = els.$root.parent();
                    els.$holder.append(els.$nav);
                    this.fade();
                }
            }
        }, options);

        result.init();
        return result;
    }

    var lines = $('.js-Line');

    if (lines.length) {
        // @TODO(Grey): I should eventually fix this so it doesn't
        // rely on such a brittle selector
        lines
            .parent()
            .parent()
            .parent()
            .parent()
            .css({'overflow-x': 'hidden'});
        $('.js-Line').each(function(i, l) { line($(l)) });
    }

}());

